import { render } from "./add-unggah_undangan.vue?vue&type=template&id=b9b8e746"
import script from "./add-unggah_undangan.vue?vue&type=script&lang=js"
export * from "./add-unggah_undangan.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__